export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_COOPERATION_DOCUMENTS_REQUEST = "FETCH_COOPERATION_DOCUMENTS_REQUEST";
export const ADD_COOPERATION_DOCUMENT_REQUEST = "ADD_COOPERATION_DOCUMENT_REQUEST";
export const DELETE_COOPERATION_DOCUMENT_REQUEST = "DELETE_COOPERATION_DOCUMENT_REQUEST";
export const DOWNLOAD_COOPERATION_DOCUMENT_REQUEST = "DOWNLOAD_COOPERATION_DOCUMENT_REQUEST";
